<template>
	<BaseCard
		:title="$t('repair_schedule').toString()"
		@clickEdit="openModal"
		:is-editable="true"
		:is-toggle-open="isToggleOpen"
		:is-toggleable="true"
		@toggleCard="toggleCard($event)"
	>
		<BaseTable :heads="heads" :rows="repairPlanRows" :mapping="mapping" v-if="repairPlanRows" :enable-search="false" ref="table" />
	</BaseCard>
</template>

<script>
import BaseCard from '@/components/damagecases/forms/BaseCard';
import ProcessRepository from '@/api/repositories/ProcessRepository';
import BaseTable from '@/components/forms/BaseTable';
import { getStringFromDate } from '@/plugins/Utils';

export default {
	name: 'ProcessRepairPlanCard',
	components: { BaseTable, BaseCard },
	props: {
		process: { required: true },
		isToggleOpen: { type: Boolean, default: true },
	},
	data() {
		return {
			repairPlanRows: null,
			heads: [
				{ title: this.$t('date'), key: 'date' },
				{ title: this.$t('time'), key: 'time' },
				{ title: this.$t('description'), key: 'name' },
			],
		};
	},
	methods: {
		toggleCard($event) {
			this.$emit('toggleCard', $event);
		},
		updateRepairPlan() {
			new ProcessRepository().getRepairPlan(this.process.id, { limit: 5, orderByDesc: ['date', 'time', 'id'] }).then(response => {
				this.repairPlanRows = response.data.data.repair_plan_rows;
			});
		},
		openModal() {
			this.$router.push({ name: 'damagecases.repairplan', params: { processId: this.$route.params.processId } });
		},
		mapping(row) {
			return {
				date: getStringFromDate(row['date']),
				time: row['time'],
				name: row['name'],
			};
		},
	},
	watch: {
		process: {
			immediate: true,
			handler() {
				this.updateRepairPlan();
			},
		},
		'$route.params': {
			handler() {
				this.updateRepairPlan();
			},
			deep: true,
		},
	},
};
</script>
